import angular from 'angular';

class depositorRouteCtrl {
  /* @ngInject */
  constructor($scope, $state, $translate, $sessionStorage, i18nService) {
    this.$scope = $scope;
    this.$state = $state;
    this.$translate = $translate;
    this.$sessionStorage = $sessionStorage;
    this.i18nService = i18nService;
  }
  $onInit() {
    this.$scope.includes = {
      depositors: require('./depositor/depositor.html'),
      depositorsConfirmation: require('./depositor-confirm/depositor-confirm.html')
    };

    // Nom de l'onglet actif
    this.activeTabName = this.activeTab.tabName;

    this.i18nService.setCurrentLang(this.$translate.use());

    if (!this.keepFilter) {
      this.$sessionStorage.depositorHistorySearchCriteria = null;
    }
    this.updateTabStatus();
  }

  updateTabStatus() {
    if (this.activeTabName === 'confirm') {
      this.activeTabIndex = 1;
    } else {
      this.activeTabIndex = 0;
    }
  }

  // Change l'onglet actif
  selectTab(tabName) {
    if (this.activeTabName === tabName) {
      return;
    }
    this.activeTabName = tabName;
    this.$state.go('depositors', { tabName: tabName, specificForm: null });
    this.updateTabStatus();
  }
}

angular.module('dashboard').component('depositorRoute', {
  templateUrl: require('./depositor-route.html'),
  controller: depositorRouteCtrl,
  bindings: {
    keepFilter: '<',
    activeTab: '<'
  }
});
